import React from 'react';
import { browserHistory } from 'react-router';
// TODO switch to React.lazy() since we don't need this components at first, potential save - 98Kb uncompressed js
import { PhotoSwipe } from 'react-photoswipe';
import I18n from 'lib/i18n/i18n';
import {
    dataAutomationAttr,
    isMobile,
    LS,
    CLICKED_EDIT_PHOTOS,
    imageUrl,
} from '../../helpers/ApplicationHelper';
import { PencilIcon, TrashcanIcon } from "components/common";
import { photosInSameLine, itemCertificateDetails } from 'helpers/itemHelper';
import WorthyApi from '../../lib/api/worthyApi';
import UploadImageComponent from './UploadImageComponent';
import GA from '../../lib/ga';
import SurveyPopup from "../surveyPopup";
import ConfirmationPopup from '../popups/confirmationPopup';
import GiaTooltip from './GiaTooltip';


const HIDDEN_CLASS = 'hidden';

class ItemDetails extends React.Component {
    constructor(props) {
        super(props);
        this.isMobile = isMobile();
        this.state = {
            clickedGalleryImage: 0,
            isGalleryOpen: false,
            imagesPreloaded: false,
            hidePhotos: true,
            gallery: [],
            hasPhoto: null,
            loading: false,
            photos: []
        };
    }

    toggleHeader = (toShow = false) => {
        if (!this.pageHeader) {
            this.pageHeader = document.querySelector('header');
        }

        if (toShow) {
            this.pageHeader.classList.add(HIDDEN_CLASS);
        } else {
            this.pageHeader.classList.remove(HIDDEN_CLASS);
        }
    };

    handleClose = () => {
        this.toggleHeader();
        this.setState({ isGalleryOpen: false });
    };

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.item.photos) !== JSON.stringify(this.props.item.photos)) {
            // Who dared to resubmit or change item's submitted photos?
            this.setState({ imagesPreloaded: false });
            this.preloadImages(this.props.item.photos);
        }
    }

    componentDidMount() {
        if (this.props.item && this.props.item.photos) {
            if (!this.props.item.photos.length) {
                this.setState({ hidePhotos: false });
            } else {
                this.setState({ photos: this.props.item.photos });
                this.preloadImages();
            }
        }
    }

    preloadImages = (photos) => {
        const imagesToBeDownload = photos || this.photos || this.props.item.photos;

        this.gallery = imagesToBeDownload ? imagesToBeDownload.map((src, idx) => {
            const j = document.createElement('img');
            const requestedSrc = src.replace('/upload', '/upload/w_' + (window.innerWidth > 1000 ? 500 : window.innerWidth));
            j.src = requestedSrc;
            // Reducing loading time from Cloudinary transformations.

            j.onload = (data) => {
                if (this.gallery[idx]) {
                    this.gallery[idx]['h'] = data.path ? data.path[0].height : data.target.height;
                    this.gallery[idx]['w'] = data.path ? data.path[0].width : data.target.width;
                }

                if (this.gallery.every(img => img.h && img.w)) {
                    this.setState({
                        imagesPreloaded: true,
                        gallery: this.gallery
                    });
                }
            };
            return { src: requestedSrc };
        }) : [];
    };

    openSwiper = (idx) => {
        const { gallery, imagesPreloaded } = this.state;
        if (gallery && imagesPreloaded) {
            this.toggleHeader(true);
            this.setState({
                clickedGalleryImage: idx,
                isGalleryOpen: true
            });
        }
    };

    logAction = (message) => {
        if (this.props.logger) {
            this.props.logger(message, {});
        }
    };

    uploadStart = () => {
        this.setState({ loading: true });
    };

    removeImage = (image) => {
        const { item } = this.props;

        WorthyApi.removeImage(item.id, image).then(() => {
            this.props.onDataChange();
        })
    };

    toUploadPhotos = (itemId, action) => {
        LS.set(`${ CLICKED_EDIT_PHOTOS }_${ itemId }`, true);
        this.logAction(`${ action } photos clicked`);
        browserHistory.push('/item/' + itemId);
    };

    onUploadSuccess = () => {
        this.logAction('add photos clicked');
        GA.lightListingPhotoUploadedSuccessfully()
        this.props.onDataChange();
    };

    initCertificateSurvey = (defaultAnswers) => {
        const { item, showCertificateAlert, onCertificateUpdate, onDataChange } = this.props;
        const isEdit = !!defaultAnswers;
        const openActionedObj = isEdit ? "editCertificateBtn" : "addCertificateBtn";
        const submitActionedObj = isEdit ? "editCertificateBtn" : "submitAddCertificateBtn";
        
        const ObjectId = item.id;
        const ObjectType = item ? "Item" : "Bundle";
        GA.giaCertificateModal.navigate(openActionedObj);

        SurveyPopup.initPopup({
            ObjectId,
            ObjectType,
            defaultAnswers,
            surveyToShow: "giaCertificate",
            showThankYouExp: false,
            onSurveyClose: (res) => {
                if (res) {
                    GA.giaCertificateModal.submitted(submitActionedObj);
                    if (res instanceof Error) {
                        showCertificateAlert('error')
                    } else {
                        showCertificateAlert('success')
                        if (res.data.can_fetch_gia_data) {
                            onCertificateUpdate();
                        } else {
                            onDataChange()
                        }
                    }
                }
                SurveyPopup.hide();
            },
        });
    }

    deleteCertificate = () => {
        const { item, onDataChange } = this.props;
        GA.giaCertificateModal.navigate('deleteCertificateBtn');
        ConfirmationPopup.initPopup({
            title: 'Delete Certificate',
            message: 'Are you sure you want to delete certificate?',
            popupClassName: 'certificate-delete--modal',
            onConfirm: async () => {
                GA.giaCertificateModal.submitted('submitDeleteCertificateBtn');
               await WorthyApi.updateCertificate(item.id, null, 'none');
               await onDataChange();
            }
        })
    }

    render() {
        const { item, clickOnBox, version } = this.props;
        const {
            isGalleryOpen,
            clickedGalleryImage,
            gallery,
            hidePhotos,
        } = this.state;

        if (item.photos.length) {
            this.logAction('add photo box presented');
        }

        const { showCertificateField, hasCertificate, canAddCertificate } = itemCertificateDetails(item);

        return <>
            <span
                className="item-upper-caption outside-box">{ I18n.getString('listingPageLight::itemDetails::packageContents') }</span>
            <section className={ 'pane-listing item-details-light-listing' }>
                <span className="item-upper-caption">#{ item.id }</span>
                <img className={ `back-arrow-blue ${ hidePhotos && 'open' }` }
                     src={ imageUrl('common/back_arrow_blue.svg') }
                     onClick={ () => this.setState({ hidePhotos: !hidePhotos }) }/>
                <h1 className={ `item-name bolder text-capitalize ${ hidePhotos && this.isMobile && 'no-space' }` }>{ item.desc }</h1>
                <ul className={ `item-details-list ${ hidePhotos && this.isMobile && 'hide' } ${ photosInSameLine(item) ? 'same-line' : 'different-line' }` }>
                    <li className="item-details-list-item">
                        <span
                            className="item-fact-title">{ I18n.getString('listingPageLight::itemDetails::photos') }</span>
                        {
                            item.photos.length ?
                                <>
                                    <PhotoSwipe
                                        key="photoswipe"
                                        options={ { index: clickedGalleryImage } }
                                        isOpen={ isGalleryOpen }
                                        items={ gallery }
                                        onClose={ this.handleClose }/>
                                    <ul className={
                                        `
                                    photo-box-list 
                                    ${ photosInSameLine(item) ? ' photo-box-list_flex-start photo-box-list_not-empty ' : '' }
                                    `
                                    }> {
                                        item.photos.map((image, idx) => {
                                            return <li
                                                data-automation={ dataAutomationAttr('item-photo-' + idx) }
                                                key={ 'photo-box' + idx }
                                                className="photo-box"
                                                style={ { backgroundImage: `url(${ image })` } }
                                                onClick={ () => {
                                                    this.openSwiper(idx);
                                                } }>
                                                <span className="remove-icon"
                                                      onClick={ (event) => {
                                                          event.stopPropagation();
                                                          this.removeImage(image);
                                                      }
                                                      }/>
                                            </li>;
                                        }) }
                                        <UploadImageComponent
                                            item={ item }
                                            clickOnBox={ clickOnBox }
                                            version={ version }
                                            onUploadSuccess={ (res) => this.onUploadSuccess(res) }
                                            uploadStart={ this.uploadStart }
                                            setPhoto={ () => this.setState({ hasPhoto: false })}
                                            logAction={this.logAction}
                                        />
                                    </ul>
                                </> : <div className="d-flex item-details-no-photo">
                                    <UploadImageComponent
                                        item={ item }
                                        clickOnBox={ clickOnBox }
                                        version={ version }
                                        onUploadSuccess={ (res) => this.onUploadSuccess(res) }
                                        uploadStart={ this.uploadStart }
                                        setPhoto={ () => this.setState({ hasPhoto: false })}
                                        logAction={this.logAction}
                                    />
                                </div>
                        }
                    </li>
                </ul>

                {(showCertificateField) && (
                        <ul className={'item-details-list item-details-list--certificate'}>
                            <li className="item-details-list-item">
                                <span className="item-fact-title">
                                    {I18n.getString(
                                        "listingPageLight::itemDetails::certificate"
                                    )}
                                    <GiaTooltip />
                                </span>
                                <div className="item-details-certificate">
                                    <img
                                        src={imageUrl(
                                            "common/certificate.svg"
                                        )}
                                    />
                                    {hasCertificate && (
                                        <>
                                            <span>
                                                {I18n.getString(
                                                    "listingPageLight::itemDetails::certificateNumber"
                                                )
                                                    .replace(
                                                        "{provider}",
                                                        item.certificate.provider
                                                    )
                                                    .replace(
                                                        "{number}",
                                                        item.certificate.number
                                                    )}
                                            </span>
                                            <a
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    this.initCertificateSurvey({
                                                        gia_cert_number_standalone: item.certificate.number
                                                    });
                                                }}
                                            >
                                                <PencilIcon stroke="#999" />
                                            </a>
                                            <a
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    this.deleteCertificate();
                                                }}
                                            >
                                                <TrashcanIcon />
                                            </a>
                                        </>
                                    )}
                                    {canAddCertificate && (
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.initCertificateSurvey();
                                            }}
                                        >
                                            {I18n.getString(
                                                "listingPageLight::itemDetails::addCertificate"
                                            )}
                                        </a>
                                    )}
                                </div>
                            </li>
                        </ul>
                    )}
            </section>
        </>;
    }
}

export default ItemDetails;
